import KendoUpload from './KendoUpload'
import KendoUploadInstaller from './kendo-upload-installer'

export { KendoUpload, KendoUpload as Upload, KendoUploadInstaller, KendoUploadInstaller as UploadInstaller }


// WEBPACK FOOTER //
// ./packages/kendo-upload-vue-wrapper/src/index.js